import React, { Component } from "react";

export class ProfileBenefitView extends Component {
  render() {
    return (
      <div>
        <h1>Profile Page - Benefits</h1>
      </div>
    );
  }
}
export default ProfileBenefitView;
